
import { customRef } from 'vue';

const storedRefs = [];

const prefix = 'nps-lewis-mountain';

export function storedRef( activity, name, value ) {

  const key = `${ prefix }-activity-${ activity }-${ name }`;

  const ref = customRef( ( track, trigger ) => ( {

    get: () => {
      
      track();

      return JSON.parse( localStorage.getItem( key ) ) || value;

    },

    set: value => {
      
      if ( value === undefined ) localStorage.removeItem( key );
      
      else localStorage.setItem( key, JSON.stringify( value ) );

      trigger();

    }

  } ) );

  storedRefs.push( { activity, ref } );

  return ref;

}

export function clearStoredRefs( activity ) {

  storedRefs.forEach( ( { activity: number, ref } ) => {

    if ( activity && number === activity || ! activity )
    
      ref.value = undefined;
  
  } );

}
